// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Modal from "../overlays/Modal.res.js";
import * as React from "react";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as IconButton from "../actions/IconButton.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  container: {
    "borderRadius-kaIpWk": "borderRadius-x12oqio5",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-x1q0g3np",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:20"
  },
  containerCompact: {
    "paddingBlock-k8WAf4": "paddingBlock-x1m7iz9m",
    "paddingInline-kg3NbH": "paddingInline-x17qtykl",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:25"
  },
  containerLarge: {
    "paddingBlock-k8WAf4": "paddingBlock-xhyosrm",
    "paddingInline-kg3NbH": "paddingInline-x1hr3lfm",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:29"
  },
  containerSuccess: {
    "backgroundColor-kWkggS": "backgroundColor-xp5y61q",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:33"
  },
  containerDanger: {
    "backgroundColor-kWkggS": "backgroundColor-xpdwwyo",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:36"
  },
  containerWarning: {
    "backgroundColor-kWkggS": "backgroundColor-x164ts2d",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:39"
  },
  containerInfo: {
    "backgroundColor-kWkggS": "backgroundColor-xbkk3a2",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:42"
  },
  text: {
    "color-kMwMTN": "color-x1wohto9",
    "font-kVVagm": "font-xyeg6z0",
    "lineHeight-kLWn49": "lineHeight-xd4r4e8",
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    "position-kVAEAm": "position-x1n2onr6",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:53"
  },
  textLink: {
    "font-kVVagm": "font-xrmhhpu",
    "lineHeight-kLWn49": "lineHeight-xd4r4e8",
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    "position-kVAEAm": "position-x1n2onr6",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:60"
  },
  textSuccess: {
    "color-kMwMTN": "color-x1l8bq95",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:66"
  },
  textDanger: {
    "color-kMwMTN": "color-x1re7szb",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:69"
  },
  textWarning: {
    "color-kMwMTN": "color-x1uycxd",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:72"
  },
  textInfo: {
    "color-kMwMTN": "color-x79xvzw",
    $$css: "wino-gc:src/resources/feedback-indicators/Banner.res.js:75"
  }
};
function containerStyleFromParams(variation, compact) {
  return Stylex.props(styles.container, variation === "warning" ? styles.containerWarning : variation === "danger" ? styles.containerDanger : variation === "success" ? styles.containerSuccess : styles.containerInfo, compact ? styles.containerCompact : styles.containerLarge);
}
function textStyleFromParams(variation, hovered) {
  return [variation === "warning" ? styles.textWarning : variation === "danger" ? styles.textDanger : variation === "success" ? styles.textSuccess : styles.textInfo, hovered ? {
    textDecorationLine: "underline"
  } : {}, {
    fontSize: "14px"
  }];
}
function make(message) {
  let defaultValue = {
    message: message,
    link: undefined
  };
  let matches = /.*(\[(.+)\]\(([^\s]+)\)).*/.exec(message);
  if (matches == null) {
    return defaultValue;
  }
  let linkCaptures = Stdlib_Array.filterMap(matches, x => x);
  if (linkCaptures.length !== 4) {
    return defaultValue;
  }
  let markdown = linkCaptures[1];
  let text = linkCaptures[2];
  let url = linkCaptures[3];
  let message$1 = message.replace(markdown, "");
  let to;
  try {
    to = {
      TAG: "Url",
      _0: new URL(url)
    };
  } catch (exn) {
    to = {
      TAG: "Route",
      _0: url
    };
  }
  return {
    message: message$1,
    link: {
      text: text,
      to: to
    }
  };
}
let RichText = {
  make: make
};
function Banner$ExpandModal(props) {
  let variation = props.variation;
  let message = props.message;
  let match = Hover.use(undefined, undefined, undefined);
  let match$1 = React.useState(() => false);
  let setOpened = match$1[1];
  let onRequestClose = () => setOpened(param => false);
  let title = variation === "danger" ? I18n.t("Errors details") : I18n.t("Details");
  let triggerText = variation === "danger" ? I18n.t("See errors detail") : I18n.t("See detail");
  let formattedMessage = message.endsWith(".") ? message.slice(0, -1) + " :" : message + " :";
  let newrecord = {
    ...{
      style: {
        marginLeft: "6px",
        marginTop: "4px"
      }
    }
  };
  let newrecord$1 = {
    ...Stylex.props(textStyleFromParams(variation, false))
  };
  let newrecord$2 = {
    ...Stylex.props(styles.textLink, textStyleFromParams(variation, match[1]))
  };
  newrecord.children = JsxRuntime.jsxs(Inline.make, {
    children: [JsxRuntime.jsx("span", (newrecord$1.children = "➔", newrecord$1)), JsxRuntime.jsx("span", (newrecord$2.children = triggerText, newrecord$2))]
  });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(Touchable.make, {
      children: JsxRuntime.jsx("div", newrecord),
      onPress: param => setOpened(param => true),
      ref: match[0]
    }), JsxRuntime.jsx(Modal.make, {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs(Box.make, {
          children: [JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsx(TextStyle.make, {
              children: formattedMessage
            }),
            spaceY: "small"
          }), JsxRuntime.jsx(Box.make, {
            children: props.children.map(detail => JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx(TextStyle.make, {
                children: " •  " + detail
              }),
              spaceY: "xxsmall"
            }, detail)),
            grow: true
          })],
          spaceX: "xlarge",
          spaceY: "normal"
        }),
        style: {
          maxHeight: "50vh",
          overflow: "auto"
        }
      }),
      opened: match$1[0],
      title: title,
      onRequestClose: onRequestClose
    })]
  });
}
function Banner(props) {
  let __helpCenterLink = props.helpCenterLink;
  let onRequestClose = props.onRequestClose;
  let __compact = props.compact;
  let details = props.details;
  let textStatus = props.textStatus;
  let compact = __compact !== undefined ? __compact : true;
  let helpCenterLink = __helpCenterLink !== undefined ? __helpCenterLink : false;
  let match = Hover.use(undefined, undefined, undefined);
  let linkHovered = match[1];
  let ref = match[0];
  let match$1;
  if (textStatus !== undefined) {
    switch (textStatus.TAG) {
      case "Success":
        match$1 = ["success", textStatus._0];
        break;
      case "Danger":
        match$1 = ["danger", textStatus._0];
        break;
      case "Warning":
        match$1 = ["warning", textStatus._0];
        break;
      case "Info":
        match$1 = ["info", textStatus._0];
        break;
    }
  } else {
    match$1 = ["info", ""];
  }
  let text = match$1[1];
  let variation = match$1[0];
  let match$2 = make(text);
  let link = match$2.link;
  let newrecord = {
    ...containerStyleFromParams(variation, compact)
  };
  let newrecord$1 = {
    ...{
      className: "font-x1qgc9lc display-x78zum5 flexBasis-x3xmw9a flexDirection-x1q0g3np flexGrow-x1iyjqo2 paddingRight-xcicffo",
      "data-style-src": "wino-gc:src/resources/feedback-indicators/Banner.res.js:45"
    }
  };
  let newrecord$2 = {
    ...Stylex.props(styles.text, textStyleFromParams(variation, false))
  };
  let tmp;
  if (link !== undefined) {
    let newrecord$3 = {
      ...{
        style: {
          marginTop: "2.5px"
        }
      }
    };
    newrecord$3.ref = Primitive_option.some(ref);
    let newrecord$4 = {
      ...Stylex.props(textStyleFromParams(variation, false))
    };
    let newrecord$5 = {
      ...Stylex.props(styles.textLink, textStyleFromParams(variation, linkHovered))
    };
    newrecord$3.children = JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx("span", (newrecord$4.children = " ➔", newrecord$4)), JsxRuntime.jsx(Navigation.Link.make, {
        children: JsxRuntime.jsx("span", (newrecord$5.children = link.text, newrecord$5)),
        to: link.to,
        openNewTab: true
      })]
    });
    tmp = JsxRuntime.jsx("div", newrecord$3);
  } else if (helpCenterLink) {
    let newrecord$6 = {
      ...{
        style: {
          marginTop: "2.5px"
        }
      }
    };
    newrecord$6.ref = Primitive_option.some(ref);
    let newrecord$7 = {
      ...Stylex.props(textStyleFromParams(variation, false))
    };
    let newrecord$8 = {
      ...Stylex.props(styles.textLink, textStyleFromParams(variation, linkHovered))
    };
    newrecord$6.children = JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx("span", (newrecord$7.children = " ➔", newrecord$7)), JsxRuntime.jsx(Touchable.make, {
        children: JsxRuntime.jsx("span", (newrecord$8.children = I18n.t("please visit the help center."), newrecord$8)),
        wrap: false,
        onPress: param => HelpCenter.showMessages()
      })]
    });
    tmp = JsxRuntime.jsx("div", newrecord$6);
  } else {
    tmp = null;
  }
  newrecord$1.children = [JsxRuntime.jsx("span", (newrecord$2.children = match$2.message, newrecord$2)), tmp, details !== undefined && details.length !== 0 ? JsxRuntime.jsx(Banner$ExpandModal, {
    children: details,
    message: text,
    variation: variation
  }) : null];
  newrecord.children = [JsxRuntime.jsxs("div", newrecord$1), onRequestClose !== undefined ? JsxRuntime.jsx(IconButton.make, {
    name: "close_light",
    marginSize: "xxsmall",
    color: variation === "warning" ? "#ab4319" : variation === "danger" ? "#c81c51" : variation === "success" ? "#125135" : "#3B54A5",
    hoveredColor: variation === "warning" ? "#ab4319" : variation === "danger" ? "#ce0340" : variation === "success" ? "#0b5135" : "#3B54A5",
    onPress: param => onRequestClose()
  }) : null];
  return JsxRuntime.jsxs("div", newrecord);
}
let make$1 = React.memo(Banner, (oldProps, newProps) => {
  if (oldProps.textStatus === newProps.textStatus && oldProps.details === newProps.details) {
    return oldProps.compact === newProps.compact;
  } else {
    return false;
  }
});
export { RichText, make$1 as make };
/* styles Not a pure module */